// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The support sheet (GiveSheet.js): the shared sheet (.apr-dialog, main.css),
   a bottom sheet with a grabber on phones and a centred 440 px dialog wider
   up. The Net speaks in the serif; the frame and the buttons are Inter. No
   fills and no hue: two equal line buttons, nothing selected, nothing louder
   than the other. Tokens only, so Light reading follows. It scrolls inside
   itself, so a short phone or 200% text still reaches every line. */

.apr-dialog.give-sheet {
  max-height: min(92vh, 720px);
  max-height: min(92dvh, 720px);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.give-sheet .give-title {
  padding-right: 44px; /* clear of the close button */
  text-wrap: balance;
}

/* The title takes focus when the sheet opens; it is not a control, so no ring. */
.give-sheet .give-title:focus {
  outline: none;
  box-shadow: none;
}

/* Opened from the card that says the window's questions are used up. */
.give-limit {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
}

.give-limit .apr-icon {
  margin-top: 3px;
  color: var(--brand-muted);
}

/* The Net, inviting: Newsreader, never under 16 px. */
.give-lead {
  margin: 0;
  max-width: var(--measure);
  font-family: var(--font-serif);
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.5;
  font-variation-settings: "opsz" 18;
  color: var(--brand-fg-read);
}

.give-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 20px;
}

.give-btn {
  width: 100%;
  padding: 0 12px;
}

.give-small {
  margin: 12px 0 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--brand-muted);
}

/* Always on the page (a status region must be there before it speaks), and
   no room at all while it has nothing to say. */
.give-wait:empty {
  margin: 0;
}

.give-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 12px 0 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--brand-muted);
}

.give-hint .apr-icon {
  margin-top: 2px;
}

.give-fine a {
  color: var(--brand-fg);
  white-space: nowrap;
}

/* "Not now" and "I already give to The Net": quiet, 44 px, on the right. */
.give-choices {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px 20px;
  margin-top: 12px;
}

/* Returned and Already. */
.give-done {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px 20px;
  margin-top: 20px;
}

.give-again {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  font-size: 0.875rem;
  line-height: 1.3;
}

.give-limit[hidden],
.give-actions[hidden],
.give-hint[hidden],
.give-choices[hidden],
.give-done[hidden],
.give-again[hidden] {
  display: none;
}

/* Short screens (a 320 x 568 phone, a landscape one): the lead steps down to 16 px. */
@media (max-height: 700px) {
  .give-lead {
    font-size: 1rem;
  }
}

@media (max-width: 600px) {
  .give-actions {
    grid-template-columns: 1fr;
  }

  .give-choices {
    justify-content: flex-start;
  }

  .give-done {
    flex-direction: column;
    align-items: stretch;
  }

  .give-again {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GiveSheet.css"],"names":[],"mappings":"AAAA;;;;;oEAKoE;;AAEpE;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB,EAAE,8BAA8B;EACnD,kBAAkB;AACpB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD;EACE,SAAS;EACT,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;gDACgD;AAChD;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA,sFAAsF;AACtF;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* The support sheet (GiveSheet.js): the shared sheet (.apr-dialog, main.css),\n   a bottom sheet with a grabber on phones and a centred 440 px dialog wider\n   up. The Net speaks in the serif; the frame and the buttons are Inter. No\n   fills and no hue: two equal line buttons, nothing selected, nothing louder\n   than the other. Tokens only, so Light reading follows. It scrolls inside\n   itself, so a short phone or 200% text still reaches every line. */\n\n.apr-dialog.give-sheet {\n  max-height: min(92vh, 720px);\n  max-height: min(92dvh, 720px);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.give-sheet .give-title {\n  padding-right: 44px; /* clear of the close button */\n  text-wrap: balance;\n}\n\n/* The title takes focus when the sheet opens; it is not a control, so no ring. */\n.give-sheet .give-title:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n/* Opened from the card that says the window's questions are used up. */\n.give-limit {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0 0 12px;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n}\n\n.give-limit .apr-icon {\n  margin-top: 3px;\n  color: var(--brand-muted);\n}\n\n/* The Net, inviting: Newsreader, never under 16 px. */\n.give-lead {\n  margin: 0;\n  max-width: var(--measure);\n  font-family: var(--font-serif);\n  font-weight: 400;\n  font-size: 1.125rem;\n  line-height: 1.5;\n  font-variation-settings: \"opsz\" 18;\n  color: var(--brand-fg-read);\n}\n\n.give-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.give-btn {\n  width: 100%;\n  padding: 0 12px;\n}\n\n.give-small {\n  margin: 12px 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--brand-muted);\n}\n\n/* Always on the page (a status region must be there before it speaks), and\n   no room at all while it has nothing to say. */\n.give-wait:empty {\n  margin: 0;\n}\n\n.give-hint {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 12px 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--brand-muted);\n}\n\n.give-hint .apr-icon {\n  margin-top: 2px;\n}\n\n.give-fine a {\n  color: var(--brand-fg);\n  white-space: nowrap;\n}\n\n/* \"Not now\" and \"I already give to The Net\": quiet, 44 px, on the right. */\n.give-choices {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 4px 20px;\n  margin-top: 12px;\n}\n\n/* Returned and Already. */\n.give-done {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px 20px;\n  margin-top: 20px;\n}\n\n.give-again {\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;\n  font-size: 0.875rem;\n  line-height: 1.3;\n}\n\n.give-limit[hidden],\n.give-actions[hidden],\n.give-hint[hidden],\n.give-choices[hidden],\n.give-done[hidden],\n.give-again[hidden] {\n  display: none;\n}\n\n/* Short screens (a 320 x 568 phone, a landscape one): the lead steps down to 16 px. */\n@media (max-height: 700px) {\n  .give-lead {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .give-actions {\n    grid-template-columns: 1fr;\n  }\n\n  .give-choices {\n    justify-content: flex-start;\n  }\n\n  .give-done {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .give-again {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
